// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3teJ8","col":"styles_col__d4ZbQ"};